var _desc, _defs, _g, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotificationRedShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1069_7517"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "36 Stroke / ds_ic_36_heart",
    width: 36,
    height: 36,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1069_7517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M28.6499 8.3584C25.8066 5.50781 21.3599 5.2417 18.2178 7.56055L18.0005 7.72656L17.7837 7.56055C14.6406 5.2417 10.1938 5.50781 7.35059 8.3584C4.21631 11.5005 4.21631 16.5952 7.35059 19.7388L17.2925 29.7065C17.6836 30.0986 18.3179 30.0986 18.709 29.7065L28.6499 19.7388C31.7842 16.5952 31.7842 11.5005 28.6499 8.3584ZM27.2324 18.3267C29.5884 15.9639 29.5884 12.1323 27.2329 9.77051C24.8784 7.41064 21.062 7.41064 18.708 9.77051C18.3169 10.1626 17.6826 10.1626 17.292 9.771C14.9365 7.41064 11.1201 7.41064 8.76562 9.77051C6.41016 12.1323 6.41016 15.9639 8.76562 18.3262L17.9995 27.5845L27.2324 18.3267ZM26.3882 17.0151L21.708 21.707C21.3179 22.0981 20.6851 22.0986 20.2939 21.709C19.9028 21.3188 19.9019 20.6855 20.292 20.2944L24.9722 15.6025C25.3623 15.2114 25.9951 15.2109 26.3862 15.6006C26.7773 15.9907 26.7783 16.624 26.3882 17.0151Z",
    clipRule: "evenodd",
    fill: "#50964E",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval 74",
    cx: 29,
    cy: 8,
    r: 4,
    fill: "#FF4500",
    fillOpacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval 74",
    cx: 29,
    cy: 8,
    r: 4.75,
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationRedShape);
export default __webpack_public_path__ + "static/media/ic_notification_red_shape.eb6b60ef3ec6724568d50a80cc3285ce.svg";
export { ForwardRef as ReactComponent };